import { defaultDealerCodesPageSize } from "@dealer-center/ddc-pages-dealer-codes-interface";

export const getDealerCodeTypesUrlToUse = () => {
  return `/landing/nxlambda/dealerCodes/`;
};

export const getDealerCodesUrlToUse = (
  accountType: string,
  pageSize?: number,
  pageNumber?: number
) => {
  return `/landing/nxlambda/dealerCodes/${accountType}/?pageSize=${
    pageSize || defaultDealerCodesPageSize
  }&pageNumber=${pageNumber || 0}`;
};

export const postDealerCodeTypeToAccountUrl = () => {
  return `/landing/nxlambda/dealerCodes/types`;
};

export const getDealerCodesByAccountIdUrl = (accountId: string) => {
  return `/landing/nxlambda/dealerCodeTypes/${accountId}`;
};

export const getDeleteDealerCodeMappingUrl = (id: string) => {
  return `/landing/nxlambda/dealerCode/mapping/${id}`;
};

export const getEditDealerCodeMappingUrl = (id: string) => {
  return `/landing/nxlambda/dealerCode/mapping/${id}`;
};
